var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "form-control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.searchQuery,
      expression: "searchQuery",
      modifiers: {
        "trim": true
      }
    }],
    ref: "searchInput",
    attrs: {
      "type": "text",
      "name": "headerOrderSearch",
      "placeholder": "Zoek op ordernummer",
      "autocomplete": "off",
      "tabindex": "1"
    },
    domProps: {
      "value": _vm.searchQuery
    },
    on: {
      "click": _vm.clickedOnInput,
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.searchQuery = $event.target.value.trim();
      },
      "blur": function ($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('span', [_vm.isSearching ? _c('font-awesome-icon', {
    staticClass: "text-secondary",
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  }) : _vm.searchQuery && _vm.isResultFound === false ? _c('font-awesome-icon', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip",
      value: `Geen resultaten. Let op: Zoek op gehele ordernummers.`,
      expression: "`Geen resultaten. Let op: Zoek op gehele ordernummers.`"
    }],
    staticClass: "ml-2 text-danger",
    attrs: {
      "icon": "ban"
    }
  }) : _vm.searchQuery && _vm.isResultFound ? _c('font-awesome-icon', {
    staticClass: "text-success",
    attrs: {
      "icon": "check-circle"
    }
  }) : _vm._e()], 1)]), _vm.searchHistory.length ? [_c(_vm.componentToShowHistory, {
    ref: "previousSearches",
    tag: "component",
    class: {
      'mt-3': !_vm.historyInOverlay
    }
  }, [_c('b-table-simple', {
    attrs: {
      "borderless": "",
      "small": ""
    }
  }, [_c('b-tr', [_c('b-td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', {}, [_vm._v("Laatste " + _vm._s(_vm.historyCount) + " zoekopdrachten:")])])], 1), _vm._l(_vm.searchHistory, function (historyItem, index) {
    return _c('b-tr', {
      key: index
    }, [_c('b-td', [_c('strong', [_vm._v(_vm._s(_vm.showHistoryDate(historyItem.searched_at)))])]), _c('b-td', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function ($event) {
          $event.preventDefault();
          _vm.searchQuery = historyItem.query;
        }
      }
    }, [_vm._v(_vm._s(historyItem.query))])])], 1);
  })], 2)], 1)] : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }